import { PanelPropDefinitions } from "../panel/PanelProps";
import { ComponentPropDefinitions, ComponentPropDefinitionUtil } from "../../base/ComponentProps";
import { Component, PanelProps, Table } from "../..";


export interface DropTargetPanelProps extends PanelProps {
  managingComponent: Component;
}

let dropTargetPanelPropDefs: ComponentPropDefinitions;

export class DropTargetPropDefinitions {
  public static getDefinitions(): ComponentPropDefinitions {
    if (dropTargetPanelPropDefs == null) {
      dropTargetPanelPropDefs = {
        ...PanelPropDefinitions.cloneDefs(),
        ...ComponentPropDefinitionUtil.getDataBoundPropertyDefinitions()
      };
      ComponentPropDefinitionUtil.populateComponentPropNames(dropTargetPanelPropDefs);
    }
    return dropTargetPanelPropDefs;
  }
}
